<template>
  <div class="end-container">
    <img src="@/assets/images/end.png" />
    <span>{{ msg }}</span>
  </div>
</template>

<script>
export default {
  computed: {
    msg() {
      const status = this.$route?.query?.status ?? "";
      if ("" === status) {
        return "会议已结束";
      } else {
        let errMap = {
          "-2": "会议未开始",
          "-1": "会议已结束",
          "-3": "会议已取消",
          "-4": "会议已过期"
        };
        return errMap[status];
      }
    }
  }
};
</script>

<style lang="less">
.end-container {
  display: flex;
  flex: 1;
  overflow: hidden;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  background: #fff;
  border-top: 1px solid #d8d8d8;
  img {
    margin: 200px 0 20px 0;
    width: 259px;
  }
  span {
    font-size: 18px;
  }
}
</style>
